module.exports = __webpack_public_path__ + "img/image-registration.10b6b5d0.png";